'use client';

import AddToCart from 'components/actions/add-to-cart/add-to-cart';
import { ALTERNATE_PARTS_LIST } from '../../../../constants/constants';
import { Product } from 'services/product/types';
import { useAlternateContext } from '../alternate-parts-context/alternate-context-provider';

interface AlternatePartCartButtonWrapperProps {
  product: Product;
  currency: string;
  storeLocationId: string;
}

const AlternatePartCartButtonWrapper: React.FC<
  AlternatePartCartButtonWrapperProps
> = ({ product, currency, storeLocationId }) => {
  const { cartDetails } = useAlternateContext();

  return (
    <div className="pt-5 pb-2">
      <AddToCart
        fullWidth={true}
        productPrice={product}
        cartId={cartDetails?.orderHeader?.orderId}
        productPriceData={product}
        currency={currency}
        itemlistIdName={ALTERNATE_PARTS_LIST}
        locationId={storeLocationId}
      />
    </div>
  );
};

export default AlternatePartCartButtonWrapper;
